import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";

export function CreditReturnDetailsViewModel(
  logout,
  creditReturnId,
  addSnackbar,
) {
  const [creditReturn, setCreditReturn] = useState({ items: [] });
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getCreditReturnDetails = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall(`creditReturn/${creditReturnId}`);
    if (callResult.success) {
      setCreditReturn(callResult.data);
      setLoading(false);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      setLoading(false);
      showErrorModal(callResult.data.message);
    }
  };

  const onUpdateCreditNote = async function (newNote) {
    var customer = customers.find(
      (customer) => customer.label === creditReturn.customer.label,
    );

    let callResult = await makePostApiCall(`updateCr/${creditReturnId}`, {
      customer_id: customer.value,
      customer_name: creditReturn.customer.label,
      ...creditReturn,
      notes: newNote,
    });
    if (callResult.success) {
      setCreditReturn({
        ...creditReturn,
        notes: newNote,
      });
      setLoading(false);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteCarton = async function (cartonId) {
    let callResult = await makePostApiCall(`askDeleteCarton/${cartonId}`);
    if (callResult.success) {
      getCreditReturnDetails();
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getCustomersForDropdown = async function () {
    let callResult = await makeGetApiCall(`customersForDropdown`);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onSaveCr = async function () {
    var customer = customers.find(
      (customer) => customer.label === creditReturn.customer.label,
    );

    let callResult = await makePostApiCall(
      `updateCr/${creditReturn.id}`,
      {
        ...creditReturn,
        customer_id: customer.value,
        customer_name: customer.label,
      },
      "multipart/form-data",
    );
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "CR updated",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const printCr = async function () {
    let callResult = await makeGetApiCall(
      `printCreditReturn/${creditReturn.id}`,
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onDeleteCr = async function () {
    let callResult = await makePostApiCall(
      `deleteCreditReturn/${creditReturn.id}`,
    );
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "CR deleted",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateCreditReturnItem = async function (id, updatedItem) {
    var payload = {
      unit_cost: updatedItem.unit_cost,
      total_cost: updatedItem.total_cost,
    };
    let callResult = await makePutApiCall(
      `updateCreditReturnItem/${id}`,
      payload,
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "CR item updated",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  function askDeleteCr() {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={onDeleteCr}
          message={`Are you sure you want to delete CR ${creditReturn.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  }

  return {
    creditReturn,
    loading,
    emptyModal,
    setEmptyModelOpen,
    setCreditReturn,
    getCreditReturnDetails,
    onUpdateCreditNote,
    askDeleteCarton,
    getCustomersForDropdown,
    customers,
    onSaveCr,
    printCr,
    askDeleteCr,
    updateCreditReturnItem,
  };
}
